import { render, staticRenderFns } from "./DraftContextMenu.vue?vue&type=template&id=4be7f24b&scoped=true"
import script from "./DraftContextMenu.vue?vue&type=script&lang=js"
export * from "./DraftContextMenu.vue?vue&type=script&lang=js"
import style0 from "./DraftContextMenu.vue?vue&type=style&index=0&id=4be7f24b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be7f24b",
  null
  
)

export default component.exports